import React from 'react'
import styled from 'styled-components'

import Tag from './Tag'

import { Label } from 'components/Text'

const InternalTag = () => <Tag text='Optional' sentiment='important' />

const breakpoint = 'md'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	align-content: flex-start;
	margin-top: 1.5rem;

	${p => p.theme.above(breakpoint)`
		flex-direction: row;
	`}
`

const ContentWrapper = styled.div`
	padding: 0.5rem 0 0 0;

	${p => p.theme.above(breakpoint)`
		padding: 0 0 0 0.5rem;
	`}
`

export default function OptionalTag(props) {
	const children = props.children

	if (!children) {
		if (props.forceBlock) {
			return (
				<Wrapper>
					<InternalTag />
				</Wrapper>
			)
		}

		return <InternalTag />
	}

	return (
		<Wrapper>
			<InternalTag />

			<ContentWrapper>
				<Label>{children}</Label>
			</ContentWrapper>
		</Wrapper>
	)
}
